import React from 'react';
import './HowToUseTab.scss';

const HowToUseTab = () => {
  return (
    <div className="language-management__instructions">
      <div className="language-management__instructions-content">
        {/* Overview Section */}
        <section className="language-management__instruction-section">
          <h2 className="language-management__instruction-title">
            Overview
          </h2>
          <p className="language-management__instruction-text">
            The Language Management system allows you to manage all translations for your application in one centralized location. This tool helps you maintain consistency across different languages and makes it easy to update translations as your application evolves.
          </p>
          <ul className="language-management__instruction-list">
            <li>Manage translation keys and their values in multiple languages</li>
            <li>Filter and search translations efficiently</li>
            <li>Import and export translations via CSV files</li>
            <li>Manage language locales (available for global administrators)</li>
          </ul>
        </section>

        {/* Language Labels Tab Section */}
        <section className="language-management__instruction-section">
          <h2 className="language-management__instruction-title">
            Language Labels Tab
          </h2>

          <div className="language-management__instruction-subsection">
            <h3 className="language-management__instruction-subtitle">
              Using Translation Keys
            </h3>
            <p className="language-management__instruction-text">
              When translating text that contains placeholders, it is important to preserve these placeholders exactly as they appear in the original text. Placeholders are used by the application to dynamically insert values.
            </p>
            <div className="language-management__instruction-text-block">
              <p className="language-management__instruction-text">
                <strong>Example 1:</strong>
              </p>
              <ul className="language-management__instruction-list">
                <li>Original: "The :attribute must be accepted test."</li>
                <li>Translation (e.g., French): "Le :attribute doit être accepté test."</li>
                <li>The <code>:attribute</code> placeholder must stay exactly the same</li>
              </ul>
              <p className="language-management__instruction-text">
                <strong>Example 2:</strong>
              </p>
              <ul className="language-management__instruction-list">
                <li>Original: "The {'{{attribute}}'} must be accepted test."</li>
                <li>Translation (e.g., French): "Le {'{{attribute}}'} doit être accepté test."</li>
                <li>The <code>{'{{attribute}}'}</code> placeholder must stay exactly the same</li>
              </ul>
            </div>
          </div>

          <div className="language-management__instruction-subsection">
            <h3 className="language-management__instruction-subtitle">
              Editing Existing Translation Keys
            </h3>
            <ol className="language-management__instruction-ordered-list">
              <li>Locate the translation key you want to edit using the search or filter options</li>
              <li>Click the edit icon (✏️) in the Actions column</li>
              <li>Update the translations for any locale</li>
              <li>Click 'Save' to apply your changes</li>
            </ol>
          </div>

          <div className="language-management__instruction-subsection">
            <h3 className="language-management__instruction-subtitle">
              Import and Export
            </h3>
            <div className="language-management__instruction-text-block">
              <p><strong>Exporting Translations:</strong></p>
                <ol className="language-management__instruction-ordered-list">
                <li>Select a second locale from the filter dropdown <b>(First Locale used as Reference and second Locale used to import translations)</b></li>
                <li>Click the 'Export CSV' button</li>
                <li>The CSV file will download with all translations for the selected locale pair</li>
              </ol>
            </div>
            <div className="language-management__instruction-text-block">
              <p><strong>Importing Translations:</strong></p>
              <ol className="language-management__instruction-ordered-list">
                <li>Prepare a CSV file following the format of the exported file</li>
                <li>Click the 'Import from CSV' button and select your file</li>
                <li>Review any import results or errors</li>
              </ol>
            </div>
          </div>
        </section>

        {/* Troubleshooting Section */}
        <section className="language-management__instruction-section">
          <h2 className="language-management__instruction-title">
            Troubleshooting
          </h2>
          <div className="language-management__instruction-subsection">
            <h3 className="language-management__instruction-subtitle">
              Common Issues and Solutions
            </h3>
            <ul className="language-management__instruction-list">
              <li>
                <strong>CSV import fails:</strong>{' '}
                Make sure your CSV file matches the exported file format and has all required columns. Translations are imported from the column after the Reference column.
              </li>
              <li>
                <strong>Changes not reflecting immediately:</strong>{' '}
                Clear your browser cache and refresh the page. Some changes may require a page reload to take effect
              </li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HowToUseTab;

